import dayjs from "dayjs";
import { Box, Typography } from "@mui/material";

import { IUploadHistory } from "./Governance.types";
import { GovernanceUploadSummary } from "./GovernanceUploadSummary";
import { GovernanceUserAvatar } from "./GovernanceUserAvatar";

type GovernanceUploadDetailProps = {
  upload: IUploadHistory;
};

const labelSx = { color: "#6F6F78", fontSize: "14px" };
const valueSx = { color: "text.primary", fontSize: "14px", fontWeight: 700 };

/** Detalhe de um upload do histórico: cabeçalho numa linha só, em vez dos blocos da Atividade. */
export function GovernanceUploadDetail({ upload }: GovernanceUploadDetailProps) {
  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: "24px", marginBottom: "24px" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Typography sx={labelSx}>Usuário:</Typography>
          <GovernanceUserAvatar name={upload.user?.name ?? null} size={24} />
          <Typography sx={valueSx}>{upload.user?.name ?? "—"}</Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Typography sx={labelSx}>Arquivo</Typography>
          <Typography sx={valueSx}>{upload.fileName ?? "—"}</Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Typography sx={labelSx}>Data de carregamento:</Typography>
          <Typography sx={valueSx}>{dayjs(upload.createdAt).format("DD/MM/YYYY - HH:mm:ss")}</Typography>
        </Box>
      </Box>

      <GovernanceUploadSummary upload={upload} />
    </Box>
  );
}
